import { log } from "console";
import React, { useState } from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import CartLoader from "../../../components/CartLoader";
import ModalLoader from "../../../components/ModalLoader";
interface ModalProps {
  setOpenModal?: React.Dispatch<React.SetStateAction<boolean>>;
  cart_id?: number | any;
  couponCode?: string | any;
}

const Modal = ({ setOpenModal, cart_id }: ModalProps) => {
  const {
    getCouponData,
    applyCoupon,
    removeCoupon,
    isCartLoadingData,
    getCartData,
    gerCartError,
    modalOpenData,
    closePopup,
    setPageData
  } = useShoppingCart();
  const [coupon, setCoupon] = React.useState<string | any>("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  let data = getCouponData;

  // console.log(gerCartError, "coupon section error");

  function handleOnChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;
    const upperCaseValue = value.toUpperCase();
    setCoupon(upperCaseValue);
    setIsButtonDisabled(upperCaseValue === "");
  }



  console.log(isButtonDisabled);

  const dataCartPrice = getCartData;
  const cartPrice = dataCartPrice?.data[0].billing_data;


  let currentURL = "";
  // Accessing the URL
  currentURL = window.location.href;
  // console.log(currentURL, "thankyou");
  function retryOrder() {
    // Redirect to the previous URL
    window.history.back();
  }

  return (
    <div className="modalBackground">
      {/* <div className=""> */}

      <div className="modalContainer">
        {isCartLoadingData && <ModalLoader />}
       
      <button
          className="popupClose"
          onClick={() => {
            if (modalOpenData.popupId === "checkout") {
              closePopup();
              setPageData(1);
            } else if (currentURL.includes("thankyou")) {
              retryOrder();
              setPageData(1);
            } else {
              closePopup();
            }
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.99032 0.990242C1.79139 0.990294 1.59699 1.04967 1.43198 1.16079C1.26697 1.2719 1.13884 1.4297 1.06399 1.61401C0.98913 1.79832 0.970941 2.00077 1.01175 2.19548C1.05255 2.39018 1.15049 2.56829 1.29305 2.70704L6.58602 8.00001L1.29305 13.293C1.19708 13.3851 1.12046 13.4955 1.06767 13.6176C1.01489 13.7397 0.987001 13.8712 0.985647 14.0042C0.984294 14.1373 1.0095 14.2692 1.05979 14.3924C1.11008 14.5156 1.18444 14.6275 1.27852 14.7216C1.3726 14.8157 1.4845 14.89 1.60768 14.9403C1.73086 14.9906 1.86283 15.0158 1.99587 15.0144C2.12891 15.0131 2.26034 14.9852 2.38247 14.9324C2.5046 14.8796 2.61497 14.803 2.70712 14.707L8.00008 9.41407L13.2931 14.707C13.3852 14.803 13.4956 14.8796 13.6177 14.9324C13.7398 14.9852 13.8713 15.0131 14.0043 15.0145C14.1373 15.0158 14.2693 14.9906 14.3925 14.9403C14.5157 14.89 14.6276 14.8157 14.7217 14.7216C14.8157 14.6275 14.8901 14.5156 14.9404 14.3924C14.9907 14.2692 15.0159 14.1373 15.0145 14.0042C15.0132 13.8712 14.9853 13.7397 14.9325 13.6176C14.8797 13.4955 14.8031 13.3851 14.7071 13.293L9.41415 8.00001L14.7071 2.70704C14.8516 2.56658 14.9503 2.38574 14.9903 2.18822C15.0302 1.9907 15.0096 1.78571 14.931 1.60013C14.8525 1.41454 14.7197 1.25701 14.5501 1.14818C14.3805 1.03935 14.182 0.984302 13.9806 0.990242C13.7208 0.997983 13.4742 1.10656 13.2931 1.29298L8.00008 6.58595L2.70712 1.29298C2.61393 1.19718 2.50248 1.12104 2.37937 1.06904C2.25625 1.01704 2.12396 0.99025 1.99032 0.990242Z"
              fill="#4F4F4F"
            ></path>
          </svg>
        </button>

        <div className="couponModalWrapper" style={{ padding: "25px 25px 0" }}>
          <h2 className="modalCouponHeading">Available Coupons</h2>
          {/* <h4 className="my-2 modalCouponSubHeading">
            You are just a step away from availing your purchase!
          </h4> */}
          <p className="cartValue">Cart Value: ₹<span>{cartPrice?.total}</span></p>
          <div className={`mt-3 codeInput ${coupon ? "hasValue" : ""}`}>
            <input
              name="couponCode"
              value={coupon}
              placeholder="Type Your Coupon Code"
              onChange={handleOnChange}
              type="text"
            />
            <button onClick={() => applyCoupon(cart_id, coupon)} className={coupon ? "activeButton" : ""} disabled={isButtonDisabled}>Apply</button>
          </div>

          {gerCartError && <div className="errorMessage">{gerCartError}</div>}
        </div>

        {data && data.data.customer_coupons?.length != 0 ? (
          <p
            style={{
              textAlign: "center",
              margin: "10px 0 2px 0",
              
            }}
            className="bestCouponHeading"
          >
            Best Coupons For You
          </p>
        ) : (
          <div>
            <p
              style={{
                textAlign: "center",
                margin: "10px 0 2px 0",
                overflow: "auto",
              }}
              className="bestCouponHeading"
            >
              No Coupons are available at this time.
            </p>
          </div>
        )}
        <div className="couponCodeList" style={{ overflow: "auto" }}>
          {data &&
            data.data.customer_coupons?.length != 0 &&
            data.data.customer_coupons?.map((item) => (
              <div
                className={`${item.enable ? "couponCodeWrapper" : "couponCodeWrapperDisable"}`}
                key={item.id}
              >
                <div className="couponCodeWrapperContent">
                <div className="codeContent">
                  <h2 
                    className={`${item.enable ? "itemCode" : "itemCodeDisable"}`}
                    >
                    {item.code}
                  </h2>
                  <h4 
                  className={`${item.enable_data.message_text_color === 'blue' ? "itemCodeMessage2" : "itemCodeMessage2Disable"}`}
                  >
                  {item.enable_data.message}
                  </h4>
                </div>
                <div className="applyCopuonCTA">
            
                  {/* <CartLoader /> */}
                  <button
                    disabled={!item.enable}
                    className={`${item.enable ? "applyCouponCTA ripple applyCouponButton" : "applyCouponCTA ripple applyCouponButtonDisable"}`}
                    onClick={() => applyCoupon(cart_id, item.code)}
                  >
                    Apply
                  </button>
                </div>
                </div>
                <div className="itemCodeMessage">
                  {item.message}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Modal;
